import { JSX, ReactNode } from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

export const getLDProvider = async (): Promise<(({ children }: { children: ReactNode }) => JSX.Element) | null> => {
  const ldClientId = window?._CMS_?.ldClientId;

  if (!ldClientId || ldClientId.trim() === '') {
    console.warn('LaunchDarkly client ID is not configured. Feature flags will be unavailable.');
    return null;
  }

  try {
    const LDProvider = await asyncWithLDProvider({
      clientSideID: ldClientId,
      context: {
        kind: 'user',
        anonymous: true,
      },
      reactOptions: {
        useCamelCaseFlagKeys: false,
      },
      options: {
        application: {
          id: 'CMS.customer',
          version: '1.0.0',
        },
      },
    });

    return LDProvider;
  } catch (error) {
    console.error('Failed to initialize LaunchDarkly provider:', error);
    return null;
  }
};
